import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../hooks/Language';

import { Container } from './styles';

const Logo: React.FC = () => {

  const { language } = useLanguage();
  const [logoValue, setLogoValue] = useState("/assets/logo-padrao.jpeg");


  useEffect(() => {

    const validLogo = {
      ptBr: "/assets/logo-padrao.jpeg",
      en: "/assets/logo-padrao.jpeg",
      es: "/assets/logo-padrao.jpeg",
    }


    setLogoValue(validLogo?.[language] ? validLogo[language] : logoValue);

  }, [language])

  return (
    <Container>
      <img src={logoValue} />
    </Container>
  );
};
export default Logo;
